export default {"src":"/_next/static/image/public/images/icon_sm_cadastro_white.d3c6c9f18bff7c7f23b6ac545b522878.svg","height":25,"width":20};